import React, { useEffect, useState } from 'react';

const CustomPage = ({ AuthService,UserService,page_id,isInternal }) => {

 

  const [pageContent,setpageContent] = useState('');

  const fetchPage = async () => {
    
    if(isInternal == true){
      return;
    }
    try {
      const response = await fetch('https://cms.spqrlab.com/api/get_page_content', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            page_id: page_id 
        }),
      });

      const data = await response.json();

      if (data.content) {
        setpageContent(data.content[0].body);
      } else {
        console.error('Error fetching buttons:', data.error);
        setpageContent('');
      }
    } catch (error) {
      console.error('Fetch error:', error);
      setpageContent('');
    } finally {
      
    }
  };


  useEffect(() => {
    fetchPage();
  }, [page_id]);


  return (
    <>
     
     {isInternal ? (
        <div className="sport-content">
          <iframe className="sport-iframe" src={page_id}></iframe>     
          </div>
          ) : (
            <div dangerouslySetInnerHTML={{ __html: pageContent }} />
          )}
    </>
  );
  
};

export default CustomPage;
